var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MembreService } from 'membre/store/service';
import { MembreDemandeSuppression } from './MembreDemandeSuppression.class';
import { AdminService } from 'admin/store/service';
/**
 * Les attributs de cet objet sont uniquement visibles par l'utilisateur
 */
export class MembrePrive {
    /**
     * Constructeur de l'objet MembrePrive
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        if (row) {
            this.nom1 = (_a = row.nom1) !== null && _a !== void 0 ? _a : null;
            this.prenom1 = (_b = row.prenom1) !== null && _b !== void 0 ? _b : null;
            this.nom2 = (_c = row.nom2) !== null && _c !== void 0 ? _c : null;
            this.prenom2 = (_d = row.prenom2) !== null && _d !== void 0 ? _d : null;
            this.societe = (_e = row.societe) !== null && _e !== void 0 ? _e : null;
            this.adresse = (_f = row.adresse) !== null && _f !== void 0 ? _f : null;
            this.complementAdresse = (_g = row.complementAdresse) !== null && _g !== void 0 ? _g : null;
            this.telephone = (_h = row.telephone) !== null && _h !== void 0 ? _h : null;
            this.mail = (_j = row.mail) !== null && _j !== void 0 ? _j : '';
            this.mailKO = (_k = row.mailKO) !== null && _k !== void 0 ? _k : null;
            this.dateEnregistrementMailKO = (_l = row.dateEnregistrementMailKO) !== null && _l !== void 0 ? _l : null;
            this.vip = (_m = row.vip) !== null && _m !== void 0 ? _m : null;
            this.membreConfiance = (_o = row.membreConfiance) !== null && _o !== void 0 ? _o : null;
            this.dateFinVip = (_p = row.dateFinVip) !== null && _p !== void 0 ? _p : null;
            this.centreInterets = (_q = row.centreInterets) !== null && _q !== void 0 ? _q : null;
            this.tempMail = (_r = row.tempMail) !== null && _r !== void 0 ? _r : null;
            this.motDePasse = (_s = row.motDePasse) !== null && _s !== void 0 ? _s : null;
            this.actif = (_t = row.actif) !== null && _t !== void 0 ? _t : null;
            this.notifications = row.notifications;
            this.demandeSuppression =
                row.demandeSuppression === null ? null : new MembreDemandeSuppression(row.demandeSuppression);
            this.nbPendingContact = (_u = row.nbPendingContact) !== null && _u !== void 0 ? _u : null;
        }
        if (row.jwt) {
            localStorage.setItem('jwt', row.jwt);
        }
    }
    /**
     * Vérifie si l'utilisateur est VIP
     * @returns True si l'utilisateur est VIP
     */
    checkVip() {
        return this.dateFinVip > Date.now() / 1000 || this.vip;
    }
    /**
     * Change le mot de apsse de l'utilisateur en bdd
     * @param oldPassword Ancien mot de passe
     * @param newPassword Nouveau mot de passe
     * @return true si action réussite
     */
    static changePassword(oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.changePassword(oldPassword, newPassword);
        });
    }
    /**
     * Envoie un nouveau à la nouvelle adresse mail de l'utilisateur
     * @return true si action réussite
     */
    static sendCode(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.sendNewCode(mail);
        });
    }
    /**
     * Utilisée pour renvoyer les informations au back.
     */
    toRaw() {
        return {
            nom1: this.nom1,
            prenom1: this.prenom1,
            nom2: this.nom2,
            prenom2: this.prenom2,
            societe: this.societe,
            adresse: this.adresse,
            complementAdresse: this.complementAdresse,
            telephone: this.telephone,
            mail: this.mail,
            mailKO: this.mailKO,
            dateEnregistrementMailKO: this.dateEnregistrementMailKO,
            vip: this.vip,
            membreConfiance: this.membreConfiance,
            dateFinVip: this.dateFinVip,
            centreInterets: this.centreInterets,
            tempMail: this.tempMail,
            motDePasse: this.motDePasse,
            actif: this.actif,
            notifications: this.notifications,
        };
    }
    /**
     * Vérifie que le mail saisie est valide (pas de mail jetable, mail pas déjà utilisé, correpond à un regex de mail)
     * @return true si le mail est valide
     */
    checkMail() {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.lookupMail(this.mail);
        });
    }
    /**
     * Change l'état de mail KO d'un membre
     * @param idMembre Identifiant du membre
     * @return True si action réussie, false sinon.
     */
    switchMailKO(idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            return AdminService.switchEmailKo(idMembre);
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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